export const endpointName = "miniSite";

export const MINI_SITE_TYPE_ID =  {
    PORTAL: 1,
    DEPARTMENT: 2,
    CLIENT: 3,
    WITHOUT_CLIENT: 4,
}

export const MINI_SITE_ICON = [
    "build", // תיקונים כלליים
    "handyman", // שירותי תיקונים
    "plumbing", // אינסטלציה
    "electrical_services", // שירותי חשמל
    "hvac", // מיזוג אוויר
    "carpenter", // נגרות
    "roofing", // תיקון גגות
    "home_repair_service", // שירותי בית
    "local_laundry_service", // שירותי כביסה
    "cleaning_services", // שירותי ניקיון
    "pest_control", // הדברה
    "lock", // מנעולן
    "key", // שכפול מפתחות
    "security", // אבטחה
    "apartment", // ניהול נכסים
    "moving", // הובלות
    "storefront", // חנויות ותיקונים
    "directions_car", // שירותי רכב
    "directions_bike", // תיקון אופניים
    "directions_boat", // תיקון סירות
    "local_taxi", // שירותי הסעות
    "electric_car", // טעינת רכבים חשמליים
    "construction", // עבודות בנייה
    "engineering", // שירותי הנדסה
    "foundation", // יסודות ובנייה
    "architecture", // אדריכלות
    "landscape", // גינון
    "park", // תחזוקת פארקים
    "pool", // תחזוקת בריכות
    "fire_extinguisher", // כיבוי אש
    "medical_services", // שירותי רפואה
    "health_and_safety", // בטיחות
    "psychology", // ייעוץ פסיכולוגי
    "elderly", // סיוע לקשישים
    "child_friendly", // טיפול בילדים
    "school", // חינוך
    "menu_book", // שירותי ספרים וספריות
    "restaurant", // מסעדות
    "fastfood", // אוכל מהיר
    "bakery_dining", // מאפיות
    "local_bar", // ברים
    "wine_bar", // שירותי יין
    "liquor", // חנויות משקאות
    "coffee", // בתי קפה
    "shopping_cart", // שירותי קניות
    "local_grocery_store", // מכולת
    "pharmacy", // בתי מרקחת
    "science", // בדיקות מעבדה
    "biotech", // בדיקות רפואיות
    "hearing", // שירותי שמיעה
    "visibility", // אופטיקה
    "fitness_center", // מכוני כושר
    "spa", // ספא
    "self_improvement", // סדנאות התפתחות אישית
    "volunteer_activism", // עמותות וסיוע
    "support", // תמיכה ושירות לקוחות
    "computer", // תיקון מחשבים
    "devices", // תיקון מכשירים אלקטרוניים
    "phone_iphone", // תיקון טלפונים
    "tv", // תיקון טלוויזיות
    "wifi", // התקנת רשתות
    "router", // שירותי אינטרנט
    "smart_home", // בתים חכמים
    "camera", // שירותי צילום
    "videocam", // הפקת וידאו
    "music_note", // שירותי מוזיקה
    "theater_comedy", // הופעות חיות
    "celebration", // הפקת אירועים
    "cake", // קונדיטוריות
    "ballot", // שירותי מסמכים
    "gavel", // שירותים משפטיים
    "account_balance", // שירותי בנקאות
    "monetization_on", // ייעוץ פיננסי
    "real_estate_agent", // תיווך נדל"ן
    "work", // שירותי תעסוקה
    "corporate_fare", // חברות ועסקים
    "business_center", // מרכזי עסקים
    "event", // ניהול אירועים
    "festival", // פסטיבלים
    "beach_access", // שירותי חוף
    "local_florist", // שירותי פרחים
    "pets", // שירותים לחיות מחמד
    "directions_walk", // טיולים והדרכות
    "directions_bus", // תחבורה ציבורית
    "flight", // שירותי תעופה
    "train", // תחנות רכבת
    "subway", // רכבת תחתית
    "tram", // רכבת קלה
    "local_shipping", // שירותי שילוח
    "emoji_transportation", // לוגיסטיקה
    "recycling", // מחזור ושירותים סביבתיים
    "eco", // שירותים אקולוגיים
    "wb_sunny", // אנרגיה סולארית
    "battery_charging_full", // אנרגיה ירוקה
    "lightbulb", // חדשנות
    "handshake", // שיתופי פעולה
    "favorite", // שירותים קהילתיים
    "info", // מידע ושירות לקוחות
    "help", // עזרה
    "star", // שירותים מומלצים
    "verified", // שירותים מאושרים
    "thumb_up", // שירותים פופולריים
    "energy_savings_leaf", // חיסכון באנרגיה
    "electric_meter", // מונים חכמים
    "power", // שליטה באנרגיה
    "bolt", // בקרי חשמל
    "settings_remote", // בקרת אנרגיה חכמה
    "developer_board", // פיקוח ובקרה טכנית
    "sensor_door", // חיישנים חכמים
    "electric_bolt", // ניהול חשמל
];


